var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"dragWhole",rawName:"v-dragWhole"}],staticClass:"scroll-content",style:({ height: _vm.height + 'px' }),attrs:{"data-action":"scrollContent"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHandle),expression:"showHandle"}],style:(_vm.handleStyle),attrs:{"data-action":"scrollHandle"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }